import { render, staticRenderFns } from "./OpsBase.vue?vue&type=template&id=225cfb1d&scoped=true"
import script from "./OpsBase.vue?vue&type=script&lang=js"
export * from "./OpsBase.vue?vue&type=script&lang=js"
import style0 from "./OpsBase.vue?vue&type=style&index=0&id=225cfb1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cfb1d",
  null
  
)

export default component.exports